import { useContext, useEffect, useState } from 'react'
import { AppContext } from '../../../contextApi/ContextApi';
import BrandSection from './BrandSection';

export default function HomeBrands({website, isDashboard, setDisplay}) {
    const { calculateDaysPassed, primary_color } = useContext(AppContext);
    const [discounted, setDiscounted] = useState([]);
    const [latest, setLatest] = useState([]);
    const filterBrands = async ()=>{
        const allProducts = website?.settings?.categories.flatMap(cat => cat.products || []);
        const discountedProducts = await Promise.all(allProducts.filter(
            p => p.hasDiscount && p.disValue > 0
        ));
        const recentProducts = await Promise.all(allProducts.filter(p => {
            const d = calculateDaysPassed(p.createdAt)
            if(d<=14){
                return p;
            }
            return null;
        }));
        setDiscounted([...discountedProducts]);
        setLatest([...recentProducts]);
    }
    useEffect(()=>{filterBrands()},[])
    
    return (
        <div className='homeBrands'>
            {discounted?.length===0 && latest?.length===0 && <h2 style={{textShadow:`2px 2px 3px ${primary_color}`}} dir='rtl'>אין כעת חדש.. תנסו שוב בהמשך!</h2>}
            {discounted?.length > 0 && <BrandSection header={"המבצעים שלנו"} data={discounted} isDashboard={isDashboard} setDisplay={setDisplay}/>}
            {latest?.length > 0 && <BrandSection header={"החדשים שלנו"} data={latest} isDashboard={isDashboard} setDisplay={setDisplay}/>}
        </div>
    )
}
